import React, { useEffect, useState } from 'react';

import { VelocityComponent } from 'velocity-react';

import Utils from 'files/Utils.js';

const FIRE = '#D63D1F';
const FIRE_GLOW = '#FF6B3D';
const SECONDARY_DARK = '#242F3F';
const MUTED_TEXT = '#6F6F6F';

// Fallback modal shown when a tel: link can't be handled by the device (see
// Utils.attemptPhoneCall). Surfaces the number so the visitor can dial or copy
// it manually. Manages its own entrance/exit animation and dismisses via
// onClose, mirroring views/BookingSuccess.js.
const CallModal = ({ phoneNumber, onClose }) => {

    const isMobile = Utils.isMobile();

    const [opacity, setOpacity] = useState(0);
    const [scale, setScale] = useState(0.95);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        let timer = setTimeout(() => {
            setOpacity(1);
            setScale(1);
        }, 20);
        return () => clearTimeout(timer);
    }, []);

    const onDismiss = () => {
        setOpacity(0);
        setScale(0.95);
        setTimeout(onClose, 250);
    }

    const onBackdropClick = evt => {
        if(evt.target === evt.currentTarget) {
            onDismiss();
        }
    }

    const onCopyNumber = async () => {
        try {
            await navigator.clipboard.writeText(phoneNumber);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch(e) {
            // clipboard unavailable — the number is shown for manual dialing
        }
    }

    return (
        <div
        onClick={onBackdropClick}
        style={{
            alignItems: 'center',
            backgroundColor: 'rgba(15,20,28,0.65)',
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
            left: 0,
            padding: 24,
            position: 'fixed',
            top: 0,
            width: '100%',
            zIndex: 9900
        }}>
            <VelocityComponent
            animation={{ opacity: opacity, scale: scale }}
            duration={250}
            easing={[250, 20]}>
                <div style={{
                    backgroundColor: '#FFFFFF',
                    border: `2px solid ${FIRE}`,
                    borderRadius: 24,
                    boxShadow: `0 0 0 4px rgba(214,61,31,0.15)`,
                    maxWidth: 440,
                    overflow: 'hidden',
                    padding: '32px 24px',
                    position: 'relative',
                    textAlign: 'center',
                    width: '100%'
                }}>
                    <div style={{
                        alignItems: 'center',
                        background: `linear-gradient(135deg, ${FIRE}, ${FIRE_GLOW})`,
                        borderRadius: '50%',
                        display: 'flex',
                        height: 56,
                        justifyContent: 'center',
                        margin: '0 auto 16px auto',
                        width: 56
                    }}>
                        <i className={'fas fa-phone'} style={{ color: '#FFFFFF', fontSize: 24 }} />
                    </div>
                    <h4 style={{
                        color: SECONDARY_DARK,
                        fontFamily: '"Poppins", sans-serif',
                        fontSize: 24,
                        fontWeight: 700,
                        margin: '0 0 8px 0'
                    }}>{'Call Us Now'}</h4>
                    <p style={{
                        color: MUTED_TEXT,
                        fontFamily: '"Lato", sans-serif',
                        fontSize: 15,
                        lineHeight: 1.6,
                        margin: '0 auto 20px auto',
                        maxWidth: 360
                    }}>{'Give us a call and we\'ll help you claim your free Emergency Fire Blanket. We\'re standing by to answer your questions.'}</p>
                    <a
                    href={`tel:+${('' + phoneNumber).replace(/\D/g, '')}`}
                    style={{
                        color: FIRE,
                        display: 'inline-block',
                        fontFamily: '"Poppins", sans-serif',
                        fontSize: 30,
                        fontWeight: 800,
                        letterSpacing: 0.5,
                        marginBottom: 20,
                        textDecoration: 'none'
                    }}>{phoneNumber}</a>
                    <div style={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        gap: 12,
                        justifyContent: 'center'
                    }}>
                        <button
                        type={'button'}
                        onClick={onCopyNumber}
                        style={{
                            alignItems: 'center',
                            background: `linear-gradient(90deg, ${FIRE}, ${FIRE_GLOW})`,
                            border: 'none',
                            borderRadius: 999,
                            color: '#FFFFFF',
                            cursor: 'pointer',
                            display: 'inline-flex',
                            fontFamily: '"Poppins", sans-serif',
                            fontSize: 16,
                            fontWeight: 600,
                            gap: 8,
                            justifyContent: 'center',
                            padding: '12px 28px',
                            transition: 'transform 0.2s'
                        }}
                        onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.05)'; }}
                        onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}>
                            <i className={`fas ${copied ? 'fa-check' : 'fa-copy'}`} style={{ fontSize: 16 }} />
                            {copied ? 'Copied!' : 'Copy'}
                        </button>
                        <button
                        type={'button'}
                        onClick={onDismiss}
                        style={{
                            backgroundColor: 'transparent',
                            border: '1px solid rgba(220,220,220,0.9)',
                            borderRadius: 999,
                            color: SECONDARY_DARK,
                            cursor: 'pointer',
                            fontFamily: '"Poppins", sans-serif',
                            fontSize: 16,
                            fontWeight: 600,
                            padding: '12px 28px'
                        }}>{'Close'}</button>
                    </div>
                </div>
            </VelocityComponent>
        </div>
    )
}

export default CallModal;
